<template>
  <div style="background-color: #f7f8fa">
    <topNav :title="$t('repair_title')" url="/fangT"></topNav>
    <div class="warp">
      <div class="orderSta clearfix">
        <div class="Num">{{ orderInfo.rmno }}</div>
        <div class="sta">
                <span style="color: #D0011B"
                      v-if="orderInfo.chg_sta=='S'">{{ $t('repair_staS') }}</span>
          <span style="color: #D0011B"
                v-if="orderInfo.chg_sta=='O'">{{ $t('repair_staO') }}</span>
        </div>
      </div>
      <div class="infoList">
        <div class="info">
          <div class="infoTop">
            <i class="iconfont icon-changfangxingbiaoqian"></i>

            {{ $t('fangTXQ_baseInfo') }}
          </div>
          <ul class="infoContent ">
            <li>{{ $t('fangTXQ_rmno') }}:<span class="infoVal">{{ orderInfo.rmno }}</span></li>
            <li>{{ $t('orderDetail_sta') }}:
              <span class="infoVal"
                    v-if="orderInfo.chg_sta=='S'">{{ $t('repair_staS') }}</span>
              <span class="infoVal"
                    v-if="orderInfo.chg_sta=='O'">{{ $t('repair_staO') }}</span></li>
            <li>{{ $t('repair_begin') }}:<span class="infoVal">{{ orderInfo.date_begin | datefomate }}</span></li>
            <li>{{ $t('repair_end') }}:<span class="infoVal">{{ orderInfo.date_end | datefomate }}</span></li>

          </ul>
        </div>
        <div class="info">
          <div class="infoTop">
            <i class="iconfont icon-changfangxingbiaoqian"></i>
            {{ $t('other') }}
          </div>
          <ul class="infoContent">
            <li>{{ $t('reason') }}:<span class="infoVal">{{ orderInfo.weixiu_reason }}</span></li>
            <li style="height:auto">{{ $t('book_remark') }}:
              <span class="infoVal">{{ orderInfo.remark }}</span>
              <span class="iconfont icon-xiugai" v-if="showEditWeixiuRemark" style="color: orange; margin-left: 10px;" @click="openModal"></span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class='updateRemark-special'>
      <mt-popup v-model="showModal" class='guestInfo-modal' popup-transition="popup-fade">
        <h2>{{$t('updateRemark_title')}}</h2>
        <div class="guestSwiper">
          <textarea class="remark" v-model="remarkNew" :placeholder="$t('placeHolder_Empty')"></textarea>
        </div>
        <div class="btn">
          <div class="unSure" @click="showModal=false">{{$t('cancel')}}</div>
          <div class="sure" @click="save">{{$t('determine')}}</div>
        </div>
      </mt-popup>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      orderInfo: {},
      showModal: false,
      remark: '',
      remarkNew: '',
      showEditWeixiuRemark: localStorage.getItem('showEditWeixiuRemark') == 'yes',
      staOOReq: {
        reasonCode: '',
        sta: '',
        remark: '',
        rmnos: '',
        beginDate: moment(moment().format('YYYY-MM-DD')).toDate(),
        endDate: moment(moment().add(1, 'd').format('YYYY-MM-DD')).toDate()
      },
    };
  },
  mounted() {
    this.getDetail()

  },
  methods: {
    openModal(){
      this.showModal = true
    },
    getDetail(){
      this.$http
        .post("/mobilepmsapi/reception/getRoomMaintLockInfo", this.$route.query)
        .then(res => {
          this.orderInfo = res.data.retVal;
          this.remark = this.orderInfo.remark
        });
    },
    save() {
      var param = this.orderInfo
      this.$http
        .post('/mobilepmsapi/reception/roomStaChgUpdateRemark', {
          remark: this.remark + ' ;    ' + this.remarkNew,
          rmnos: this.orderInfo.rmno
        })
        .then(res => {
          if (res.data.result == 0) {
            //更新成功
            this.msg2(this.$t('msg_update_success'));
            this.getDetail()
            this.remarkNew = ''
            this.showModal = false
          } else {
            this.msg2(res.data.msg);
          }
        });
    },
  },
  filters: {
    datefomate(value) {
      return moment(value, "YYYY-MM-DD HH:mm:ss").format("YYYY/MM/DD HH:mm");
    }
  },
  components: {}
};
</script>

<style lang="less" >
.updateRemark-special {
  .guestInfo-modal {
    width: 90%;
    height: 330px;
    position: absolute;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 10px;
    h2 {
      font-size: 18px;
      color: #666666;
      text-align: center;
      font-style: normal;
      padding: 10px 0;
    }
    .mint-cell-title {
      width: 80px;
    }
    .guestSwiper {
      padding: 0 4%;
      p {
        font-size: 18px;
        color: #57b658;
        padding: 20px 0 20px 5px;
      }
    }
    .btn {
      height: 55px;
      border-top: 1px solid #bdbdbd;
      text-align: center;
      font-size: 16px;
      position: absolute;
      bottom: 0;
      width: 100%;
      .unSure {
        border-right: 1px solid #bdbdbd;
        width: 50%;
        box-sizing: border-box;
        float: left;
        line-height: 55px;
      }
      .sure {
        width: 50%;
        box-sizing: border-box;
        float: left;
        line-height: 55px;
        color: #5190c3;
      }
    }
  }
  .remark {
    width: 100%;
    height: 5rem;
    padding: 15px;
    box-sizing: border-box;
  }
}

.warp {
  margin: 10px auto;
  width: 96%;
  background-color: #fff;

  .orderSta {
    background-color: #d2d6de;
    height: 26px;
    line-height: 26px;
    color: #333;
    margin-bottom: 15px;

    .Num {
      float: left;
      margin-left: 8px;
    }

    .sta {
      float: right;
      margin-right: 8px;
    }
  }

  .infoList {
    .info {
      padding: 0px 0px 15px;

      .infoTop {
        padding: 0 18px;
        position: relative;
        height: 20px;
        line-height: 20px;

        .icon-changfangxingbiaoqian {
          position: absolute;
          font-size: 12px;
          left: 0;
          top: 1px;
          color: #f6a624;
        }
      }

      .infoContent {
        margin: 0 20px;
        padding: 10px 0;
        border-bottom: 1px dashed #ddd;

        li {
          height: 20px;
          line-height: 20px;

          .infoVal {
            margin-left: 8px;
          }
        }

        &.twocol {
          overflow: hidden;

          li {
            width: 50%;
            float: left;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// repair.vue?f2dcd0c8